import { withoutKey } from './utils.js';
export const applyLocaleState = (localeState) => (state) => {
    if (Object.keys(localeState).length > 0) {
        return { ...state, ...localeState };
    }
    return state;
};
export const withoutNavigatorPostalCode = withoutKey('navigatorPostalCode');
export const selectLocaleState = (state) => {
    const { navigatorPostalCode, language, acceptLanguage, clientIP } = state;
    return {
        navigatorPostalCode,
        language,
        acceptLanguage,
        clientIP,
    };
};
